import React from 'react';
import Image from 'react-bootstrap/Image';
import skriftligLogo from '../../../images/skriftlig-logo.png';

function LogoWritten() {
    
    return  <Image src={skriftligLogo} fluid alt="skriftlig-verktoypartner-logo"/>;
    
}
export default LogoWritten;